import { v4 as uuid } from 'uuid';
import { ButtonSecondary, ButtonSize, IconExpand, IconLoader } from '@ui/src';
import AdditionalInfoBlock from '../additional-info-block';
import { TaxResidenceTypes } from './types';
import CRSAndFatca from './crs-and-fatca';
import { CustomerStatus } from '../../../../../hoc/common/types';
import { CRSAndFatcaFormValues } from '../../../../../hoc/new-application/types';

import cn from '../corporate-questionnarie/styles.module.css';

const isOdd = (order: number) => {
  const result = order % 2;

  return Boolean(result);
};

const TaxResidence = ({
  errors,
  crsAndFatcaIsLoading,
  crsAndFatcaIsFetching,
  crsAndFatcaValues,
  setCrsAndFatcaValues,
  countries,
  status,
  onDeleteCRSAndFatca,
  selectedCrsAndFatcaId,
  deleteCrsAndFatcaInProgress,
}: TaxResidenceTypes) => (
  <AdditionalInfoBlock title="Tax residence">
    <div className={cn.accountsCurrenciesList}>
      {errors?.questionnairesCrsFatcaDeclarations?.message && (
        <div className={cn.questionnarieError}>
          {errors?.questionnairesCrsFatcaDeclarations?.message}
        </div>
      )}
      {!crsAndFatcaIsLoading && !crsAndFatcaIsFetching && (
        <>
          <div className={cn.accountsCurrencyListWrapper}>
            <div className={cn.accountsCurrenciesColumn}>
              {crsAndFatcaValues
                ?.filter((item, index) => !isOdd(index))
                ?.map((item) => (
                  <CRSAndFatca
                    key={item.id}
                    crsAndFatca={item}
                    setCrsAndFatcaValues={setCrsAndFatcaValues}
                    countries={countries}
                    index={crsAndFatcaValues?.findIndex(
                      (crsAndFatca) => crsAndFatca.id === item.id,
                    )}
                    status={status}
                    crsAndFatcaValues={crsAndFatcaValues}
                    onDeleteCRSAndFatca={onDeleteCRSAndFatca}
                    selectedCrsAndFatcaId={selectedCrsAndFatcaId}
                    deleteCrsAndFatcaInProgress={deleteCrsAndFatcaInProgress}
                  />
                ))}
            </div>
            <div className={cn.accountsCurrenciesColumn}>
              {crsAndFatcaValues
                ?.filter((item, index) => isOdd(index))
                ?.map((item) => (
                  <CRSAndFatca
                    key={item.id}
                    crsAndFatca={item}
                    setCrsAndFatcaValues={setCrsAndFatcaValues}
                    countries={countries}
                    index={crsAndFatcaValues?.findIndex(
                      (crsAndFatca) => crsAndFatca.id === item.id,
                    )}
                    status={status}
                    crsAndFatcaValues={crsAndFatcaValues}
                    onDeleteCRSAndFatca={onDeleteCRSAndFatca}
                    selectedCrsAndFatcaId={selectedCrsAndFatcaId}
                    deleteCrsAndFatcaInProgress={deleteCrsAndFatcaInProgress}
                  />
                ))}
            </div>
          </div>
          {status !== CustomerStatus.CLOSED && (
            <ButtonSecondary
              text="Add tax residence"
              icon={<IconExpand />}
              className={`button-white ${cn.addAccountCurrencyButton}`}
              size={ButtonSize.SMALL}
              onClick={() => {
                let nextCrsAndFatca: CRSAndFatcaFormValues[] = [];

                if (crsAndFatcaValues) {
                  nextCrsAndFatca = ([] as CRSAndFatcaFormValues[]).concat(
                    crsAndFatcaValues,
                  );
                }

                nextCrsAndFatca.push({
                  id: `crs-and-fatca-${uuid()}`,
                  residenceCountryId: '',
                  taxIdentificationNumber: '',
                  noTinReason: '',
                });

                setCrsAndFatcaValues(nextCrsAndFatca);
              }}
            />
          )}
        </>
      )}
      {(crsAndFatcaIsLoading || crsAndFatcaIsFetching) && (
        <div className={cn.accountsCurrenciesLoader}>
          <IconLoader />
        </div>
      )}
    </div>
  </AdditionalInfoBlock>
);

export default TaxResidence;
